import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectProducts } from '../../features/productSlice';
import CardList from '../Cards/CardList';
import SearchBox from './SearchBox/SearchBox';
import Navigation from '../Navigation/navigation';
import Footer from '../Footer/Footer';
import PandaBuySignUpLink from '../PandaBuySignUpLink/PandaBuySignUpLink';
import { Helmet } from 'react-helmet';

const Products = () => {
  const productsState = useSelector(selectProducts);
  const [search, setSearch] = useState(''); // Track search term
  const [filteredProducts, setFilteredProducts] = useState([]);

  // Filter products based on search term
  useEffect(() => {
    applyFilters();
  }, [productsState.products, search]);

  const applyFilters = () => {
    let filtered = [...productsState.products];

    // Filter by search term if provided
    if (search.trim() !== '') {
      filtered = filtered.filter(product => {
        // Convert the search term and product searchName to lowercase and replace "+" with space for accurate comparison
        const productSearchName = product.searchName.toLowerCase().replace(/\+/g, ' ');
        const searchTerm = search.toLowerCase().trim();

        return productSearchName.includes(searchTerm);
      });
    }
    
    setFilteredProducts(filtered);
  };

  const handleSearchSubmit = (searchTerm) => {
    setSearch(searchTerm); // Update search term when user submits
  };

  return (
    <>
      <Helmet>
        <title>Cnfans Spreadsheet containing 7000+ finds</title>
        <meta name="description" content="Discover an collection of over 7000 cnfans finds on our web-based spreadsheet." />
        <meta name="keywords" content="Cnfans shoes, Cnfans tracksuit, CNFans Stussy clothing, Cnfans Trapstar, Cnfans Moncler, Taobao agents, Weidian agents" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://cnfansspreadsheet.com/products" />
        <link rel="sitemap" type="application/xml" title="Sitemap" href="https://cnfansspreadsheet.com/sitemap.xml" />
        <script type="application/ld+json" src="/schema.org.json"></script>
      </Helmet>
      <PandaBuySignUpLink />
      <Navigation />
      <h1 className='text-xl text-gray-800 mb-2 font-bold text-center p-6 mx-auto max-w-3xl'>Browse CNfans products</h1>
      <SearchBox onSearchSubmit={handleSearchSubmit} />
      <CardList products={filteredProducts} search={search} />
      <Footer />
    </>
  );
};

export default Products;
